document.addEventListener('DOMContentLoaded', function () {
  const splide_iwt = new Splide('.iwt-carousel-slider', {
    perPage: 1,
    arrows: true,
    pagination: false,
    autoHeight: true
  });

  splide_iwt.mount();

});